export const RECORD_USERINFO = "RECORD_USERINFO"
export const LOGOUT = "LOGOUT"